export default __webpack_public_path__ + "static/media/docker.4b337013.svg";